export const variables = {
    API_URL: "https://api-lapolvadera.master-planner.net/api/",
    // API_URL: "https://localhost:7214/api/",
    PHOTO_URL: "Images"
}